import { Environment, generateEmptyApi } from '@environment';
import { carouselTypeParams } from './commons/carousel-type-params';
export const environment: Environment = {
  api: generateEmptyApi(),
  appType: 'cdp',
  siteName: 'FilmOne',

  movieSiteGlobalConfig: {
    mainLogoTreatment: {
      treatmentWhenContrastBlack:
        'https://cdnstatic.usheru.com/img/channels/filmone.usheru.com/filmone-logo-450-black.png',
      treatmentWhenContrastWhite:
        'https://cdnstatic.usheru.com/img/channels/www.filmoneng.com/header/filmone-logo-450.png'
    }
  },
  movieSiteConfig: {
    'ant-man-and-the-wasp-quantumania': {}
  },
  customPageParams: {
    headerFixed: true,
    translationHeader: true,
    seeMorePos: 'middle',
    seeMoreType: 4,
    login: 'popup',
    uPlayer: true,
    headerSMsearchCollapse: true,
    headerSMsearchActive: true,
    goToBottomHomePage: false,
    favicon: 'assets/favicon.jpg',
    moviesInitialSortComingSoon: ['locReleaseDate', 'sortAsc'],
    moviesInitialSortInCinemas: ['locReleaseDate', 'recordCount', 'sortDesc']
  },
  moviesCatalogueConfig: {
    movieCardsFullScreenWidth: true
  },

  components: {
    removeColorsHTML: {
      movieSiteEnabled: true
    },
    uiAddItemComponent: {
      alternativeStyle: true
    }
  },
  movieFilters: {
    all: {
      film: true,
      extraFilters: {
        genres: true
      }
    },

    inCinemas: {
      film: true,
      location: true,
      cinema: true,
      extraFilters: {
        genres: true
      }
    },

    watchAtHome: {
      film: true,
      streamingCountry: true,
      streaming: true,
      extraFilters: {
        genres: true
      }
    },

    comingSoon: {
      film: true,
      extraFilters: {
        genres: true
      }
    }
  },
  customFeatures: {},
  community: true,
  communityConfig: {
    role: 'film-interactions',
    collectionsConfig: {
      collectionCategoryTitle: false,
      collectionImage: false
    },
    filmInteractionsConfig: {
      watchedIcon: 'eye'
    },
    profileConfig: {
      displayName: false,
      avatar: false,
      privacy: false,
      savedSections: {
        hashtags: false,
        platforms: false
      }
    }
  },
  showStreamingTitleAlways: true,
  //
  carouselTypeParams: carouselTypeParams,
  movieCrew: {
    movieCrewRoleListing: [
      'crew.role.directing.director',
      'crew.role.acting.actor',
      'crew.role.production.producer',
      'crew.role.writing.writer'
    ]
  },
  placeholderData: {
    // performancesGroup: true,
    // movie: 'clifford-the-big-red-dog',
    // nearestCities: true
  }
};
